import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Box, Container } from "@mui/material";
import { Home } from "./ui/Home";
import { CompanyDetailsPage } from "./ui/CompanyDetailsPanels/CompanyDetailsPage";
import { OfficerDetailsPage } from "./ui/OfficerDetailsPanels/OfficerDetailsPage";
import { SearchResultPage } from "./ui/SearchResultPage";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./ui/theme";
import { Header } from "./ui/Components/Header";
import { Footer } from "./ui/Components/Footer";
import { PAPER_GREY } from "./ui/colors";
import { AuthProvider } from "./auth/AuthContext";
import { LoginPage } from "./ui/Auth/LoginPage";
import { PortfolioPage } from "./ui/PortfolioPage";
import { ApiDocsPage } from "./ui/ApiDocsPage";
import { BillingPage } from "./ui/BillingPage";
import { CheckoutReturnPage } from "./ui/CheckoutReturnPage";
import { ToastHost } from "./ui/Components/Toast";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
      <ToastHost />
      <Router>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            backgroundColor: PAPER_GREY,
          }}
        >
          <Header />
          <Box style={{ flex: 1, paddingTop: 30, paddingBottom: 30 }}>
            <Routes>
              <Route
                path="/"
                element={
                  <Container>
                    <Home />
                  </Container>
                }
              ></Route>
              <Route
                path="/login"
                element={
                  <Container>
                    <LoginPage />
                  </Container>
                }
              ></Route>
              <Route
                path="/portfolio"
                element={
                  <Container>
                    <PortfolioPage />
                  </Container>
                }
              ></Route>
              <Route
                path="/billing"
                element={
                  <Container>
                    <BillingPage />
                  </Container>
                }
              ></Route>
              <Route
                path="/billing/return"
                element={
                  <Container>
                    <CheckoutReturnPage />
                  </Container>
                }
              ></Route>
              <Route path="/search">
                <Route
                  path=":searchText"
                  element={
                    <Container>
                      <SearchResultPage />
                    </Container>
                  }
                />
              </Route>
              <Route path="/company">
                <Route
                  path=":companyNo"
                  element={
                    <Container>
                      <CompanyDetailsPage />
                    </Container>
                  }
                />
              </Route>
              <Route
                path="/officers/:resourceId/:details"
                element={
                  <Container>
                    <OfficerDetailsPage />
                  </Container>
                }
              />
              {/* Not wrapped in <Container> - Redoc renders its own full-width
                  three-pane layout, and public/marketing so no auth gate. */}
              <Route path="/api-docs" element={<ApiDocsPage />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
